// Author YuJiaBei
// Date 2021-01-05 11:16:47

import * as model from "@/model/em/lifecycle/EmLcSdSelectionDemSdeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmLcSdSelectionDemSde(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_LIFECYCLE_URL,
        callbackApi: process.env.VUE_APP_EM_LIFECYCLE_URL + '/emLcSdSelectionDemSde/workflow/complete-feedback',
        processDefinitionKey: "em_lifecycle_selection_demonstration",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'task2Entity',
        entityConstructor: model.EmLcSdSelectionDemSde
    })
    .buildStore()
